// extracted by css-extract-rspack-plugin
export default {"savingIcon":"TaskDraftSaveStatus_savingIcon__EaNNF","spin":"TaskDraftSaveStatus_spin__ZyiO2"};